<div class="content">


  <div class="form-groups-row buffer-bottom">
    <div class="form-group">
      <label>Companies</label>
      <app-company-picker [accountId]="job.company_Id" (onCompanySet)="onCompanyChange($event)"></app-company-picker>
    </div>

    <div class="form-group">
      <label>Locations</label>
      <app-location-picker [locationId]="job.location_Id" [companyId]="job.company_Id" (onLocationSet)="onLocationChange($event)"></app-location-picker>
    </div>

    <div class="form-group">
      <label>Engineer</label>
      <app-technician-picker [technicianId]="job.engineer_Id" [_placeholder]="'All'" (onTechnicianSet)="onTechnicanChange($event)"></app-technician-picker>
    </div>
  </div>
  <div class="form-groups-row buffer-bottom">

    <div class="form-group">
      <label>Contract Number</label>
      <input type="text" class="form-control" [(ngModel)]="job.contract_No" [disabled]="true" />
    </div>

    <div class="form-group">
      <label>Job Number</label>
      <input type="number" class="form-control" [(ngModel)]="job.job_No" placeholder="leave blank to auto allocate" [disabled]="editMode" />
    </div>

    <div class="form-group">
      <label>Week Commencing</label>
      <p-calendar name="week_Commencing"
                  firstDayOfWeek="1"
                  [style]="{'width':'100%', 'border-color':'#ccc', 'padding':'5px 10px','height': 'calc(1.5em + .75rem + 2px)'}"
                  [inputStyle]="{'width':'100%', 'border-color':'#ccc', 'padding':'5px 10px','height': 'calc(1.5em + .75rem + 2px)'}"
                  [(ngModel)]="job.week_Commencing" dateFormat="dd/mm/yy"
                  (ngModelChange)="week_CommencingChanged()"></p-calendar>
    </div>

    <div class="form-group">
      <label>Proposed Date</label>
      <p-calendar name="proposed_Date"
                  firstDayOfWeek="1"
                  [style]="{'width':'100%', 'border-color':'#ccc', 'padding':'5px 10px','height': 'calc(1.5em + .75rem + 2px)'}"
                  [inputStyle]="{'width':'100%', 'border-color':'#ccc', 'padding':'5px 10px','height': 'calc(1.5em + .75rem + 2px)'}"
                  [(ngModel)]="job.proposed_Date" dateFormat="dd/mm/yy"></p-calendar>
    </div>
  </div>
  <div class="form-groups-row buffer-bottom">
    <div class="form-group">
      <label>Job Comments</label>
      <textarea class="form-control" [(ngModel)]="job.job_Comments"></textarea>
    </div>

    <div class="form-group">
      <label>Scheduling Comments</label>
      <textarea class="form-control" [(ngModel)]="job.secheduling_Comment"></textarea>
    </div>
  </div>

  <div class="buffer-bottom" *ngIf="job.location_Id != null">

    <ngx-datatable class="material" [rows]="rows" [columnMode]="'force'" [headerHeight]="50" [footerHeight]="50"
                   [rowHeight]="'auto'" [limit]="10" *ngIf="!loading">

      <ngx-datatable-column name="Select">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <span (click)="select(row)" class="edit-option"><input type="checkbox" [(ngModel)]="row.selected"/> Select</span>
        </ng-template>
      </ngx-datatable-column>


      <ngx-datatable-column name="Description" prop="description">
        <ng-template let-value="value" ngx-datatable-cell-template>
          <div>{{ value }}</div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="Serial #" prop="serial_Num">
        <ng-template let-value="value" ngx-datatable-cell-template>
          <div>{{ value }}</div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="Plant #" prop="asset_Num">
        <ng-template let-value="value" ngx-datatable-cell-template>
          <div>{{ value }}</div>
        </ng-template>
      </ngx-datatable-column>


    </ngx-datatable>


  </div>



  <div class="action-buttons">
    <button class="btn btn-primary" (click)="save()">Save</button>
    <div class="spacer"></div>
    <button class="btn btn-back" (click)="back()">Back</button>
  </div>
</div>
